import mqtt from 'mqtt'

export function createMqttTransportClient({
  brokerUrl,
  mqttOptions = {},
  onClose,
  onConnect,
  onError,
  onMessage,
  onReconnect,
}) {
  const client = mqtt.connect(brokerUrl, mqttOptions)

  if (typeof onConnect === 'function') {
    client.on('connect', onConnect)
  }
  if (typeof onMessage === 'function') {
    client.on('message', onMessage)
  }
  if (typeof onReconnect === 'function') {
    client.on('reconnect', onReconnect)
  }
  if (typeof onClose === 'function') {
    client.on('close', onClose)
  }
  if (typeof onError === 'function') {
    client.on('error', onError)
  }

  return { brokerUrl, client }
}
